import { useCallback } from "react"

import { api } from "./api"
import { useSession } from "./session"
import { useAuthState } from "./states/auth-state"

export function useSwitchWorkspace() {
	const { session } = useSession()
	const setSessionData = useAuthState((s) => s.setSessionData)

	const mutation = api.auth.changeWorkspace.useMutation({
		onSuccess: (data) => {
			// update the workspaceId otherwise after the reload the old value will be read from localStorage before updating via the query
			if (session) {
				setSessionData({
					...session,
					workspaceId: data.workspaceId,
				})
			}
			window.location.reload()
		},
	})

	const { mutate, isLoading } = mutation
	const switchTo = useCallback(
		(workspaceId: string) => {
			if (isLoading || workspaceId === session?.workspaceId) {
				return
			}
			mutate({ workspaceId })
		},
		[isLoading, mutate, session?.workspaceId],
	)

	return { switchTo, isSwitching: isLoading }
}
